var _defs, _rect, _rect2, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 816,
    zoomAndPan: "magnify",
    viewBox: "0 0 612 791.999994",
    height: 1056,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c2d24dc240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 139.03125 229.03125 L 472.78125 229.03125 L 472.78125 562.78125 L 139.03125 562.78125 Z M 139.03125 229.03125 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -61.2,
    width: 734.4,
    fill: "#ffffff",
    y: -79.199999,
    height: 950.399992,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -61.2,
    width: 734.4,
    fill: "#ffffff",
    y: -79.199999,
    height: 950.399992,
    fillOpacity: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 321.933594 345.859375 L 321.933594 372.992188 L 356.097656 372.992188 L 351.316406 410.105469 L 321.933594 410.105469 L 321.933594 495.160156 L 284.679688 495.160156 L 284.679688 410.105469 L 252.765625 410.105469 L 252.765625 372.992188 L 284.679688 372.992188 L 284.679688 345.859375 C 284.679688 316.476562 308.4375 296.65625 337.820312 296.65625 C 350.753906 296.65625 358.910156 298.621094 358.910156 298.621094 L 358.910156 329.972656 L 337.820312 329.972656 C 329.105469 329.972656 321.933594 337.144531 321.933594 345.859375 Z M 321.933594 345.859375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c2d24dc240)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 305.90625 562.78125 C 213.964844 562.78125 139.03125 487.992188 139.03125 395.90625 C 139.03125 303.824219 213.964844 229.03125 305.90625 229.03125 C 397.992188 229.03125 472.78125 303.964844 472.78125 395.90625 C 472.78125 487.851562 397.992188 562.78125 305.90625 562.78125 Z M 305.90625 238.171875 C 218.886719 238.171875 148.171875 308.886719 148.171875 395.90625 C 148.171875 482.929688 218.886719 553.644531 305.90625 553.644531 C 392.929688 553.644531 463.644531 482.929688 463.644531 395.90625 C 463.644531 308.886719 392.929688 238.171875 305.90625 238.171875 Z M 305.90625 238.171875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg14);
export default __webpack_public_path__ + "static/media/14.107f36f8dcec9fc120910114245111ff.svg";
export { ForwardRef as ReactComponent };